import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClientoverviewblack = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 10,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#2B2B2B",
		d: "M7.999 0c4.918 0 7.813 4.573 7.935 4.768a.441.441 0 0 1 0 .464C15.812 5.427 12.917 10 8 10 3.08 10 .185 5.427.063 5.223a.441.441 0 0 1 0-.455C.185 4.573 3.08 0 8 0zM8 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm0 1a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"
	})
});
export default SvgClientoverviewblack;
